import styled, { css } from 'styled-components';
import { withRouter } from 'react-router-dom';
import colors from '@theme/colors';

export const NavButton = styled.button`
  padding: 0;
  outline: none;
  border: none;
  background-image: none;
  background-color: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
  margin-bottom: 30px;
  color: ${colors.TEAL_LIGHT};

  ${({ to, location: { pathname } }) =>
    to === pathname &&
    css`
      color: inherit;
      pointer-events: none;
      cursor: default;
    `}
`;

export default withRouter(NavButton);



// WEBPACK FOOTER //
// ./components/atoms/NavButton.js